<mat-sidenav-container
  autosize
  [hasBackdrop]="hasBackdrop"
  (backdropClick)="onSidebarToggle()"
>
  <mat-sidenav
    *ngIf="
      (authService.isInitialized$ | async) &&
      authService.isAuthorized &&
      !isRouteLoading
    "
    class="opclient-dark-theme mat-elevation-z4 navigation"
    (keydown.escape)="onSidebarToggle()"
    [class.hidden]="!isLogoLoaded"
    [class.sidenav-collapsed]="isSidenavCollapsed"
    [class.sidenav-mobile]="isMobile"
    [class.sidenav-tablet]="isTabletPortrait"
    [mode]="mode"
    [opened]="opened"
    disableClose
  >
    <button
      mat-mini-fab
      color="primary"
      class="menu-button"
      *ngIf="!isMobile && !isOptimalInsightsNav"
      (click)="onSidebarToggle()"
      aria-label="Toggle navigation menu"
    >
      <mat-icon [class.rotated]="isSidenavCollapsed">chevron_left</mat-icon>
    </button>
    <mat-list class="header-list">
      <mat-list-item class="header-logo navigation-item" *ngIf="!hasTopNav">
        <img
          matListItemAvatar
          class="header-logo-icon"
          src="assets/optimal-logo.svg"
          alt="O"
          (load)="isLogoIconLoaded = true"
        />
        <div class="navigation-text" matListItemTitle>
          <img
            src="assets/optimal-wordmark.svg"
            alt="OPTIMAL"
            (load)="isLogoTextLoaded = true"
          />
        </div>
      </mat-list-item>
    </mat-list>
    <mat-nav-list
      [ngClass]="{ 'mobile-nav-list': hasTopNav }"
      (click)="onNavigate()"
    >
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          home
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Dashboard</span>
      </a>
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/sales"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          monetization_on
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Sales</span>
      </a>
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/purchases"
        routerLinkActive="nav-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          shopping_cart
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Purchases</span>
      </a>
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/inventory"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          confirmation_number
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Inventory</span>
      </a>
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/reports"
        routerLinkActive="navigation-active"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          dashboard
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Reporting</span>
      </a>

      <a
        mat-list-item
        class="navigation-item"
        *ngIf="authService.canAccessPayments"
        routerLink="/payments"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          point_of_sale
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Payments</span>
      </a>

      <a
        mat-list-item
        class="navigation-item"
        *ngIf="authService.canAccessPoAccounts"
        routerLink="/purchasing-accounts"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          manage_accounts
        </mat-icon>
        <span class="navigation-text" matListItemTitle>PO Accounts</span>
      </a>

      <a
        mat-list-item
        class="navigation-item"
        *ngIf="authService.canManageWorkQueues && featureFlags.workQueues"
        routerLink="/work-queue-builder"
        routerLinkActive="navigation-active"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          list
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Work Queues</span>
      </a>
    </mat-nav-list>

    <h3
      class="navigation-heading navigation-text"
      *ngIf="
        (authService.isManager || authService.isAdmin) &&
        authService.canAccessAccounts
      "
    >
      Management
    </h3>
    <ng-container *ngIf="featureFlags.accounts">
      <mat-nav-list
        *ngIf="
          (authService.isManager || authService.isAdmin) &&
          authService.canAccessAccounts
        "
        (click)="onNavigate()"
      >
        <a
          mat-list-item
          class="navigation-item"
          *ngIf="authService.canAccessAccounts"
          routerLink="/manager/accounts"
          routerLinkActive="navigation-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon matListItemIcon class="navigation-icon" color="primary">
            group
          </mat-icon>
          <span class="navigation-text" matListItemTitle>Accounts</span>
        </a>
      </mat-nav-list>
    </ng-container>

    <h3
      class="navigation-heading navigation-text"
      *ngIf="
        (authService.isInitialized$ | async) &&
        (authService.isManager || authService.isAdmin)
      "
    >
      Administration
    </h3>
    <mat-nav-list
      *ngIf="
        (authService.isInitialized$ | async) &&
        (authService.isManager || authService.isAdmin)
      "
      (click)="onNavigate()"
    >
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/admin/users"
        routerLinkActive="nav-list-item-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          group
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Users</span>
      </a>
      <a
        mat-list-item
        class="navigation-item"
        routerLink="/admin/vendors"
        routerLinkActive="navigation-active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          person
        </mat-icon>
        <span class="navigation-text" matListItemTitle>Vendors</span>
      </a>
      <ng-container *ngIf="featureFlags.cirqueDuSoleil">
        <a
          mat-list-item
          class="navigation-item"
          routerLink="/integrations/cirque-du-soleil"
          routerLinkActive="navigation-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon matListItemIcon class="navigation-icon" color="primary">
            group
          </mat-icon>
          <span class="navigation-text" matListItemTitle>Cirque du Soleil</span>
        </a>
      </ng-container>
      <ng-container
        *ngIf="(authService.isInitialized$ | async) && authService.isAdmin"
      >
        <a
          mat-list-item
          class="navigation-item"
          routerLink="/admin/refresh-skybox-items"
          routerLinkActive="navigation-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon matListItemIcon class="navigation-icon" color="primary">
            sync_problem
          </mat-icon>
          <span class="navigation-text" matListItemTitle>Refresh Items</span>
        </a>
      </ng-container>
      <ng-container
        *ngIf="(authService.isInitialized$ | async) && authService.isAdmin"
      >
        <a
          mat-list-item
          class="navigation-item"
          routerLink="/admin/system-settings"
          routerLinkActive="navigation-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon matListItemIcon class="navigation-icon" color="primary">
            settings
          </mat-icon>
          <span class="navigation-text" matListItemTitle>System Settings</span>
        </a>
      </ng-container>
    </mat-nav-list>
    <span class="mat-sidenav-filler"></span>
    <mat-action-list>
      <button
        mat-list-item
        class="navigation-item two-line-item"
        (click)="refreshService.requestRefresh()"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          autorenew
        </mat-icon>
        <span matListItemTitle class="navigation-text navigation-item-line-one"
          >Refresh</span
        >
        <span
          *ngIf="refreshService.isActive"
          class="navigation-text navigation-item-additional"
          matListItemLine
        >
          {{ refreshService.refreshTime }}
        </span>
      </button>
      <button
        mat-list-item
        class="navigation-item"
        [class.navigation-active]="isProfileOpened"
        (click)="onProfileClick()"
      >
        <mat-icon matListItemIcon class="navigation-icon" color="primary">
          account_circle
        </mat-icon>
        <span class="navigation-text" matListItemTitle>{{
          authService.fullName
        }}</span>
      </button>
    </mat-action-list>
  </mat-sidenav>
  <mat-sidenav-content *ngIf="!isRouteLoading">
    <mat-toolbar *ngIf="hasTopNav" class="horizontal-navigation">
      <div class="logo-and-nav">
        <!-- Logo -->
        <div class="header-logo">
          <img
            src="assets/optimal-logo.svg"
            alt="O"
            (load)="isLogoIconLoaded = true"
          />
          <div
            class="logo-text"
            *ngIf="
              (isMobile && !isOptimalInsightsNav) ||
              (!isMobile && isOptimalInsightsNav)
            "
          >
            <img
              src="assets/optimal-wordmark.svg"
              alt="OPTIMAL"
              (load)="isLogoTextLoaded = true"
            />
          </div>
        </div>

        <!-- Horizontal Nav -->
        <nav *ngIf="isOptimalInsightsNav">
          <button
            mat-button
            *ngIf="!isSingleVendor"
            [matMenuTriggerFor]="vendorMenu"
            class="horizontal-link"
          >
            Team
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #vendorMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let vendor of vendors; trackBy: trackVendorsBy"
              [routerLink]="['/reports/insights']"
              [queryParams]="getVendorParams(vendor)"
            >
              {{ vendor.teamName }}
            </button>
          </mat-menu>

          <a
            mat-button
            *ngIf="isSingleReport"
            class="horizontal-link"
            routerLinkActive="active-link"
            routerLink="/reports/insights"
          >
            Report
          </a>
          <button
            mat-button
            *ngIf="!isSingleReport"
            [matMenuTriggerFor]="reportMenu"
            class="horizontal-link"
            [ngClass]="{ 'active-link': isActive('/reports/insights') }"
          >
            Report
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #reportMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let report of reports; trackBy: trackReportsBy"
              [routerLink]="['/reports/insights']"
              [queryParams]="getReportParams(report)"
            >
              {{ report.name }}
            </button>
          </mat-menu>

          <a
            mat-button
            *ngIf="authService.isOptimalInsightsUser"
            class="horizontal-link inventory-link"
            routerLinkActive="active-link"
            routerLink="/inventory/optimal-insights"
          >
            <span class="text">Inventory</span>
            <mat-icon color="text">confirmation_number</mat-icon>
          </a>
        </nav>
      </div>

      <!-- Menu or Avatar Button -->
      <button
        *ngIf="!authService.isOptimalInsightsUser"
        mat-stroked-button
        (click)="onSidebarToggle()"
      >
        Menu
      </button>
      <button
        mat-icon-button
        aria-label="My Profile"
        *ngIf="authService.isOptimalInsightsUser"
        (click)="onProfileClick()"
      >
        <mat-icon class="icon-large">account_circle</mat-icon>
      </button>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
